"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 31: NSF (infiniteneslives) — lecteur NSF simplifié
 * ------------------------------------------------------------------ */
function register(Mappers) {
  Mappers[31] = function (nes) {
    this.nes = nes;
  };
  Mappers[31].prototype = new Mappers[0]();
  Mappers[31].prototype.irqClockRate = "none";

  Mappers[31].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("NSF: Invalid ROM! Unable to load.");
    }
    // NSF : le format est géré comme une ROM NROM (PRG fixe $8000/$C000)
    this.loadPRGROM();
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();
    this.nes.cpu.requestIrq(this.nes.cpu.IRQ_RESET);
  };
}

module.exports = { register: register };
